/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from "react";
import { Fade } from "react-awesome-reveal";

const AboutCompany = () => {
  return (
    <div className="container px-6 py-12 mx-auto ">
      <Fade bottom triggerOnce>
        <div className="flex flex-col items-center justify-between gap-8 lg:flex-row">
          <div className="flex flex-col gap-6 lg:flex-row">
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=400&q=80"
                alt="Interior office"
                className="object-cover w-64 rounded-lg shadow-md h-80"
              />
              <div className="absolute inset-0 transition-opacity bg-teal-100 opacity-0 hover:opacity-50" />
            </div>
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1501785888041-af3ef285b470?ixlib=rb-4.0.3&auto=format&fit=crop&w=300&h=400&q=80"
                alt="City skyline"
                className="object-cover w-64 rounded-lg shadow-md h-80"
              />
              <div className="absolute inset-0 transition-opacity bg-teal-100 opacity-0 hover:opacity-50" />
            </div>
            <div className="relative flex items-center justify-center">
              <div className="flex flex-col items-center justify-center p-6 bg-teal-100 rounded-lg shadow-md h-80">
                <h3 className="mb-2 text-4xl font-bold text-teal-700">20+</h3>
                <p className="text-center text-gray-600">
                  LOCATIONS WORLD WIDE
                </p>
              </div>
            </div>
          </div>
          <div className="text-center lg:w-1/2 lg:text-left">
            <p className="mb-2 text-sm text-teal-500">ABOUT COMPANY</p>
            <h2 className="mb-4 text-4xl font-bold text-gray-800">
              Your Partner in Growth and Innovation
            </h2>
            <p className="mb-6 text-gray-600">
              Katella Venture Capital LLC is a private investment firm focused
              on supporting innovative startups and growing businesses. We
              partner with passionate entrepreneurs who are building the future
              in technology, healthcare, sustainability, and other high-impact
              sectors.
            </p>
            <div className="flex items-center justify-center gap-4 mb-4 lg:justify-start">
              <div className="flex items-center">
                <svg
                  className="w-6 h-6 mr-2 text-teal-500"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" />
                </svg>
                <span className="text-gray-600">Call experts</span>
              </div>
              <span className="font-semibold text-gray-800">903-293-2500</span>
            </div>
            <a
              href="/contact"
              className="inline-block px-6 py-3 text-white transition bg-teal-500 rounded-lg hover:bg-teal-600"
            >
              CONTACT US
            </a>
            <p className="mt-4 italic text-teal-500">
              Investing With Purpose and Passion
            </p>
            <p className="text-gray-600">
              We&apos;re here for you even from start to finish.
            </p>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default AboutCompany;
